import React from 'react';
import Helmet from 'react-helmet';

import { getConfigProperty } from 'Common/config';
import { withoutTrailingSlash } from 'Common/urls/util';

function HomeMetas({ config }) {
  const primaryDomain = getConfigProperty(config, 'primary_domain');
  const host = getConfigProperty(config, 'host');
  const canonicalUrl = `${withoutTrailingSlash(primaryDomain || host)}/`;

  return <Helmet link={[{ rel: 'canonical', href: canonicalUrl }]} />;
}

export default HomeMetas;
